// extracted by mini-css-extract-plugin
module.exports = {"cover":"Landing_cover__2bdj2","title":"Landing_title__3MjtS","button":"Landing_button__2jaAz","pokemon":"Landing_pokemon__2pEAO"};